module.exports = __webpack_public_path__ + "img/antes_despues_153.39ad2bad.png";